import { Injectable } from '@angular/core';
import { ColumnStateEvent } from '../components/datagrid/datagrid.component';
import { ViasConnectionService } from './vias-connection.service';

export interface ViasUserPref {
  userId?: number;
  tableState?: ColumnStateEvent[];
  // dashboard
  // menu fav.
  // nottif.
}

@Injectable({
  providedIn: 'any'
})
export class ViasUserPrefService {
  constructor(private viasService: ViasConnectionService) { }

  async getPref(userId: number): Promise<ViasUserPref> {
    return await this.viasService.send(10, 0, {
      user_id: userId
    }).then(response => {
      let userPrefs: ViasUserPref = { userId };
      if (response.error !== null && response.error !== undefined && response.error.length > 0) {
        console.log('error user pref');
      } else if (response.data) {
        if (response.data['prefs'] !== undefined) {
          const r = response.data['prefs'];
          userPrefs = JSON.parse(r.prefs);
        }
      }
      return userPrefs;
    });
  }

  setPref(userPrefs: ViasUserPref): void {
    this.viasService.send(10, 2, {
      user_id: userPrefs.userId,
      prefs: JSON.stringify(userPrefs)
    });
  }

  resetPref(userId: number): void {
    this.viasService.send(10, 4, {
      user_id: userId
    });
  }

}
